import React from 'react';
import { motion } from 'framer-motion';

const Instructions: React.FC = () => {
  return (
    <div className="w-full max-w bg-gradient-to-br from-[#050505] via-[#0a0a0a] to-[#111111] rounded-2xl shadow-xl border border-teal-600 p-4">
      <div className="text-center text-2xl font-mono text-cyan-400 py-4 border-b border-teal-600 tracking-widest uppercase">
        How to Use
      </div>

      <div className="p-4 h-[70vh] overflow-y-auto space-y-6 text-sm font-mono text-gray-300 scrollbar-thin scrollbar-thumb-cyan-500 scrollbar-track-gray-800">
        <div>
          <motion.h2
            className="text-green-400 text-xl mb-2"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.5 }}
          >
            ⚡ Quick Start Guide
          </motion.h2>

          {/* Solana Instructions */}
          <motion.h3
            className="text-pink-400 text-lg mb-2"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.7 }}
          >
            🔗 Solana (Phantom Wallet)
          </motion.h3>
          <motion.ol
            className="list-decimal list-inside space-y-1"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.9 }}
          >
            <li>Open the <strong className="text-cyan-400">Phantom</strong> wallet app.</li>
            <li>Visit <code className="text-yellow-400">aicrypto.vercel.app</code>.</li>
            <li>Type <code className="text-yellow-400">connect solana</code>.</li>
            <li>Approve the wallet connection.</li>
            <li>Start mining: <code className="text-yellow-400">mining start</code></li>
            <li>Stop mining: <code className="text-yellow-400">mining stop</code></li>
            <li>Withdraw: <code className="text-yellow-400">withdraw</code> → <strong>Confirm</strong>.</li>
            <li><em>(Optional)</em> Stake SOL: <code className="text-yellow-400">stake</code> or <code className="text-yellow-400">unstake</code></li>
          </motion.ol>

          {/* Ethereum Instructions */}
          <motion.h3
            className="text-pink-400 text-lg mt-4 mb-2"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.7 }}
          >
            🔗 Ethereum / EVM (MetaMask)
          </motion.h3>
          <motion.ol
            className="list-decimal list-inside space-y-1"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.9 }}
          >
            <li>Open <strong className="text-cyan-400">MetaMask</strong> wallet app.</li>
            <li>Visit <code className="text-yellow-400">aicrypto.vercel.app</code>.</li>
            <li>Connect: <code className="text-yellow-400">connect ethereum</code>, <code className="text-yellow-400">base</code>, <code className="text-yellow-400">arbitrum</code>, <code className="text-yellow-400">optimism</code>, <code className="text-yellow-400">bnb</code>.</li>
            <li>Approve wallet connection.</li>
            <li>Start mining: <code className="text-yellow-400">mining start</code></li>
            <li>Stop mining: <code className="text-yellow-400">mining stop</code></li>
            <li>Withdraw: <code className="text-yellow-400">withdraw</code> → <strong>Confirm</strong>.</li>
            <li><em>(Optional)</em> Stake ETH/BNB: <code className="text-yellow-400">stake</code> or <code className="text-yellow-400">unstake</code></li>
          </motion.ol>

          {/* Notes Section */}
          <motion.h3
            className="text-pink-400 text-lg mt-4 mb-2"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.7 }}
          >
            🧠 Notes
          </motion.h3>
          <motion.ul
            className="list-disc list-inside space-y-1"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.9 }}
          >
            <li>Check balance: <code className="text-yellow-400">balance</code></li>
            <li>Switch chains anytime: <code className="text-yellow-400">disconnect</code> + <code className="text-yellow-400">connect [chain]</code></li>
          </motion.ul>
        </div>
      </div>
    </div>
  );
};

export default Instructions;
